import type { Bookmark, Highlight, Selection } from '../models/selections';

export function isBookmark(selection: Selection): selection is Bookmark {
  return selection.isBookmark;
}

export function isHighlight(selection: Selection): selection is Highlight {
  return !selection.isBookmark;
}
